import { formatCurrency } from '@utils/price-formatter/format-currency';

import { calculateAddonPrice } from './calculate-addon-price';
import type { TotalPriceProps } from './calculate-booking-price.type';
import { calculateDDP } from './calculate-ddp';
import { calculateOnlinePrice } from './calculate-online-price';

export const totalOnlinePrice = ({ offer, addons = [], quantity, selectedAddons = [] }: TotalPriceProps) => {
  if (!offer) return 0;
  let number = 0;
  number += calculateOnlinePrice({ offer, quantity });
  if (calculateDDP(offer)) {
    number += calculateDDP(offer) * quantity;
  }
  if (selectedAddons.length > 0)
    number += calculateAddonPrice({
      addons: addons.filter((addon) => selectedAddons.includes(addon.id)) ?? [],
      quantity,
    });
  const currency = offer.price.currency;
  return formatCurrency({
    number,
    currency,
  });
};
